module.exports = __webpack_public_path__ + "static/img/logo2.705b84b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.gif
// module id = vFye
// module chunks = 1